import {observable, action} from 'mobx';
import _ from 'lodash';
class EditableCategoryStore {

  @observable object_id = null;
  @observable type = null;

  @action activate = (type, object_id) => {
    this.object_id = object_id;
    this.type = _.assign(type);
  };

  @action deActivate = () => {
    this.object_id = null;
    this.type = null;
  };

}

export default new EditableCategoryStore();



// WEBPACK FOOTER //
// ./src/stores/EditableCategoryStore.js